import { IconButton } from 'component/Button'
import { RoundButton } from 'component/Button/RoundButton'
import { Image } from 'component/Image'
import { Modal } from 'component/Modal'
import { Gap, Space } from 'component/Space'
import { Typo } from 'component/Typo'
import { Vertical } from 'component/Vertical'
import { session } from 'feature/widget/SessionStore'
import { useEffectOnce } from 'hook/useEffectOnce'
import { useLatestCallback } from 'hook/useLatestCallback'
import { i18n } from 'i18n'
import { Icon } from 'icon/Icon'
import { when } from 'mobx'
import { observer } from 'mobx-react-lite'
import { Powered } from 'page/catalog/Powered/Powered'
import css from './LogoutModal.module.scss'

export const LogoutModal = observer(() => {
  const { picture, timer } = session
  const min = Math.trunc(timer / 60)
    .toFixed()
    .padStart(2, '0')
  const sec = (timer % 60).toFixed().padStart(2, '0')

  useEffectOnce(() => {
    return when(
      () => session.timer === 0,
      () => session.stop(),
    )
  })

  const onClose = useLatestCallback(async () => {
    session.cancel()
  })

  const onLogout = useLatestCallback(async () => {
    session.stop()
  })

  return (
    <Modal open={true} rootClassName={css.root} className={css.modal} width={640} onCancel={onClose} closeButton={false}>
      <Space pad={32} right>
        <IconButton link action={onClose}>
          <Icon size={32} name="close" secondary />
        </IconButton>
      </Space>
      <Vertical pad={[0, 32]} center>
        <Space className={css.circle} width={120} height={120} pad={8} center round>
          <Space className={css.picture} width={104} height={104} center round>
            {picture && <Image src={picture} />}
            {!picture && <Icon size={64} name="person" tertiary />}
          </Space>
        </Space>
        <Gap height={48} />
        <Typo size={24}>
          {i18n('session.SessionWillEndIn')}
        </Typo>
        <Gap height={12} />
        <Typo size={80} bold>
          {min}:{sec}
        </Typo>
        <Gap height={40} />
        <Vertical gap={12} wide>
          <RoundButton height={64} primary onClick={onClose}>
            <Typo size={20} medium>
              {i18n('session.Stay')}
            </Typo>
          </RoundButton>
          <RoundButton height={64} onClick={onLogout}>
            <Typo size={20} medium>
              {i18n('session.End')}
            </Typo>
          </RoundButton>
        </Vertical>
      </Vertical>
      <Space height={64} center>
        <Powered />
      </Space>
    </Modal>
  )
})
